import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

// `suffix` is a server-supplied marker printed after the amount — "+ Fuel costs"
// on a launch estimate whose fill-up has not been pumped yet. The caller decides
// whether a row carries one; this only prints it.
const Subtotal = ({ label, amount, suffix = null, currency = "USD" }) => {
  return (
    <div className="flex items-center justify-between text-gray-600">
      <span>{label}</span>
      <span>
        {formatCurrencyFromMinorUnits({ amount, currency })}
        {suffix ? ` ${suffix}` : null}
      </span>
    </div>
  )
}

Subtotal.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  suffix: PropTypes.string,
  currency: PropTypes.string,
}

export default Subtotal
